import { render, staticRenderFns } from "./TeamForm.vue?vue&type=template&id=24c7f17b&scoped=true&"
import script from "./TeamForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./TeamForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TeamForm.vue?vue&type=style&index=0&id=24c7f17b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c7f17b",
  null
  
)

export default component.exports